import React from 'react';
import { useParams } from 'react-router-dom';
import { getAudioDetail } from '@/service/audioList';
import BgURL from '../Share/assets/bg.png';
import DiskBgURL from '../Share/assets/disk-bg.png';
import DiskLusterURL from '../Share/assets/disk-luster.png';
import ArmURL from '../Share/assets/arm.png';
import CoverURL from '../Share/assets/cover.png';
import TimerURL from '../Share/assets/timer.png';
import { WaveForm } from '../Share/WaveForm';
import { cn, displayDuration } from '@/utils';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import { useRequest } from 'ahooks';
import { getPrivateShareAudio } from '@/service/share';
import { toast } from 'sonner';

const Share: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { play, pause, isPlaying } = useAudioPlayerStore();

  if (!id) {
    return null;
  }
  const { data } = useRequest(() => getPrivateShareAudio({ id: id }), {
    onError: () => {
      toast.info('need login first');
    },
  });
  const audioInfo = data?.data;

  return (
    <>
      <div className="w-full h-full bg-[#111] flex justify-center items-center">
        <div
          className="w-[358px] h-[535px] relative top-0 lg:top-[-262px]"
          style={{
            background: `url(${BgURL}) no-repeat`,
            backgroundSize: 'cover',
            transform: window.innerWidth > 1024 ? 'scale(2)' : 'scale(1)',
          }}
        >
          <div
            className=" absolute top-[29px] left-[19px] w-[320px] h-[320px]"
            style={{
              background: `url(${DiskBgURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />
          <div
            className=" absolute top-[47px] left-[37px] w-[284px] h-[284px]"
            style={{
              background: `url(${DiskLusterURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />

          <div
            className={cn(' absolute top-[59px] left-[48px]  w-[262px] h-[262px] animate-spin-slow')}
            style={{
              background: `url(${CoverURL}) no-repeat`,
              backgroundSize: 'cover',
              animationPlayState: isPlaying ? 'running' : 'paused',
            }}
          />
          <div
            className=" absolute top-[29px] left-[33px]  w-[320px] h-[320px]"
            style={{
              background: `url(${ArmURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />

          <div className="content w-full h-[76px]  mt-[387px] px-[17px]  text-[#67666d]">
            <div className=" w-full h-full py-[7px] px-[5px] flex flex-col gap-[4px]">
              {audioInfo?.duration && <WaveForm songId={id} duration={audioInfo?.duration} />}
              <div className="flex justify-between font-pressura-mono text-[8px] leading-[8px]">
                <div>0:00</div>
                <div>{displayDuration(audioInfo?.duration)}</div>
              </div>
              <div
                className="w-full h-[8px]"
                style={{
                  background: `url(${TimerURL}) no-repeat`,
                  backgroundSize: 'cover',
                }}
              ></div>
              <div className="flex justify-between items-center gap-[8px]">
                <div className="text-[10px] leading-[14px] truncate">{audioInfo?.name}</div>
                <div className="font-pressura-mono text-[8px] leading-[8px]">{audioInfo?.user?.name}</div>
              </div>
            </div>
          </div>
          <div className={cn('control')}>
            <div
              className={cn('play absolute bottom-0 left-0 w-[165px] h-[55px] cursor-pointer')}
              onClick={() => {
                audioInfo &&
                  play({
                    url: audioInfo.source_url,
                    name: audioInfo.name,
                    duration: audioInfo?.duration,
                    id,
                  });
              }}
            ></div>
            <div
              className={cn('pause absolute bottom-0 left-[167px] w-[55px] h-[55px] cursor-pointer')}
              onClick={() => {
                pause();
              }}
            ></div>
            <div
              onClick={() => {
                window.open('/', '_blank');
              }}
              className={cn('play absolute bottom-0 left-[224px] w-[55px] h-[55px] cursor-pointer')}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Share;
